export default "__VITE_ASSET__CGURBB_4__"